import commitMutation from 'relay-commit-mutation-promise';
import { graphql, type Environment } from 'react-relay';
import { type SelectorStoreUpdater } from 'relay-runtime';
import {
    type addPhotoLikeMutation as MutationType,
    type AddPhotoLikeMutationInput,
} from './__generated__/addPhotoLikeMutation.graphql.ts';

const mutation = graphql`
    mutation addPhotoLikeMutation($input: AddPhotoLikeMutationInput!) {
        addPhotoLikeMutation(input: $input) {
            photoLikeId
        }
    }
`;

type UpdaterFnType = SelectorStoreUpdater<MutationType['response']>;

type AddPhotoLikeInput = {
    environment: Environment;
    input: AddPhotoLikeMutationInput;
    updater?: UpdaterFnType;
    optimisticUpdater?: UpdaterFnType;
};

export const addPhotoLikeMutation = ({
    environment,
    input,
    updater,
    optimisticUpdater,
}: AddPhotoLikeInput): Promise<MutationType['response']> => {
    return commitMutation<MutationType>(environment, {
        mutation,
        variables: { input },
        updater,
        optimisticUpdater,
    });
};
